import {
  LcmStudioChannels,
  type LcmStudioMessageChannel,
} from "@hightouch/lib/llm/lifecycle-studio/types";
import { PHONE_FRAME_WIDTH } from "src/pages/lifecycle-studio/copy/components/preview/phone-frame";

export const MESSAGE_PREVIEW_NODE_ID = "message-preview";

/** PhoneFrame is fixed 280px wide; push cards are `sm` (384px). The preview
 * renders bare — no extra node chrome around it. */
export const MESSAGE_PREVIEW_NODE_WIDTH: Record<
  LcmStudioMessageChannel,
  number
> = {
  [LcmStudioChannels.Sms]: PHONE_FRAME_WIDTH,
  [LcmStudioChannels.Push]: 384,
};

/** The rendered message preview inside a message editor, for hosts that animate onto it. */
export function findMessagePreviewNode(container: ParentNode) {
  return container.querySelector<HTMLElement>(
    `.react-flow__node[data-id="${MESSAGE_PREVIEW_NODE_ID}"]`,
  );
}
